import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconFolderStyle0 = cosmosIconCss;

const CosmosIconFolder$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconFolder extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '275f401a1accad945d8ef301ff6f7c09353993e7', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '3220cb778f5f4b64f836909ec3df852e344ba2ba', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '077ebd314320edd53790831ef67a589fb69bc39a', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m10 5.5.87 1.72a.5.5 0 0 0 .44.28h7.19v9h-15v-11H10ZM2.5 4a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h17a.5.5 0 0 0 .5-.5v-11a.5.5 0 0 0-.5-.5H12l-.87-1.72a.5.5 0 0 0-.49-.28H2.5Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconFolderStyle0; }
}, [1, "cosmos-icon-folder", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-folder"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-folder":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconFolder$1);
            }
            break;
    } });
}

const CosmosIconFolder = CosmosIconFolder$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconFolder, defineCustomElement };
